import { select, all, call, put, takeEvery, cancel } from 'redux-saga/effects';

import { putPrivacySettings, graphql } from '../../../globals/api/requests';

import actions, {
  TRACKING_TOGGLE_SAVE,
  TRACKING_TOGGLE_SAVE_SUCCESS,
} from '../actions/tracking';

export function* saveTrackingSettings({ tracking, isLoggedIn }) {
  if (isLoggedIn) {
    try {
      yield all(
        Object.entries(tracking).map(([key, value]) =>
          call(
            graphql,
            `
              mutation($data: SettingInputType!) {
                updateSetting(data: $data) {
                  success
                }
              }
            `,
            {
              data: {
                setting: key,
                value: value ? '1' : '0',
              },
            }
          )
        )
      );
    } catch (e) {
      yield put(actions.trackingToggleSaveError({ ...tracking, error: true }));
      yield cancel();
    }
  }
  try {
    const response = yield call(putPrivacySettings, tracking);
    if (response.status !== 200) {
      throw new Error('tracking save failed');
    } else {
      yield put(actions.trackingToggleSaveSuccess(tracking));
    }
  } catch (e) {
    yield put(actions.trackingToggleSaveError({ ...tracking, error: true }));
  }
}

export function* trackingSettingsSaved() {
  yield window.location.reload();
}

export function* userLoggedIn(action) {
  const trackingSettings = yield select(
    state => state.areas.user.tracking.settings
  );

  const tracking = action.me.privacySettings.reduce(
    (settings, setting) => ({
      ...settings,
      [setting.name]: setting.active,
    }),
    {}
  );

  const isEqual = Object.entries(tracking).reduce(
    (equal, [name, value]) => equal && value === trackingSettings[name],
    true
  );

  if (!isEqual) {
    yield put(actions.trackingToggleSave(tracking, true));
  }
}

function* mySaga() {
  yield takeEvery('USER_RECEIVE', userLoggedIn);
  yield takeEvery(TRACKING_TOGGLE_SAVE, saveTrackingSettings);
  yield takeEvery(TRACKING_TOGGLE_SAVE_SUCCESS, trackingSettingsSaved);
}

if (IS_BROWSER) {
  window.registerSaga(mySaga);
}

export default mySaga;
